<div *ngIf="gaPrepLevel >= 4 || nationalPrepLevel >= 4" class="decisionSupportNumber">
	<b>Wildland Fire Decision Support Center - 208-387-5253</b>
</div>
<mat-toolbar id="topToolBar" [style.backgroundColor]="bannerColor">
	<mat-toolbar-row *ngIf="this.toolbarOverflowing === false" class="routes">
		<div class="actions">
			<mat-menu #userMenu="matMenu" yPosition="below">
				<button class="rm-outline" *ngIf="authenticationService.isLoggedIn" mat-menu-item [routerLink]="authenticationService.isLoggedIn ? 'users/profile' : null">
					View Profile
				</button>
				<button
					*ngIf="userIsElevated"
					class="rm-outline"
					mat-menu-item
					[ngClass]="userIsElevated ? '' : 'inactive-routeButton'"
					[routerLink]="userIsElevated ? '/users/search' : null">
					Search Users
				</button>
				<a *ngIf="authenticationService.isLoggedIn" routerLink="/gae-staff-report" class="rm-outline" mat-menu-item>GAE Staff</a>
				<button class="rm-outline" mat-menu-item (click)="openDialog()">
					{{ authenticationService.isLoggedIn ? "Log Out" : "Login" }}
				</button>
			</mat-menu>
		</div>
		<div class="container-container">
			<div class="route-container">
				<a id="wfdss-logo" href="https://wfdss.firenet.gov/help" target="_blank" rel="noopener noreferrer" aria-label="Link to WFDSS Help website">
					<img src="assets/images/wfdss/wfdss_logo_only.svg" alt="WFDSS Help Website" />
				</a>
				<a
					class="routeLink textLink"
					[ngClass]="userIsElevated ? '' : 'inactive-routeLink'"
					[routerLinkActive]="[userIsElevated ? 'active' : '']"
					[routerLink]="userIsElevated ? '/myHome' : null"
					>My Home</a
				>
				<a
					class="routeLink textLink"
					[ngClass]="userIsElevated ? '' : 'inactive-routeLink'"
					[routerLinkActive]="[userIsElevated ? 'active' : '']"
					[routerLink]="userIsElevated ? '/incidents' : null"
					>Incidents</a
				>
				<a
					class="routeLink textLink"
					[ngClass]="userIsElevated ? '' : 'inactive-routeLink'"
					[routerLinkActive]="[userIsElevated ? 'active' : '']"
					[routerLink]="userIsElevated ? '/reports' : null"
					>Reports</a
				>
				<a
					*ngIf="authenticationService.currentUser?.isSupport"
					class="routeLink textLink"
					[ngClass]="userIsElevated ? '' : 'inactive-routeLink'"
					[routerLinkActive]="[userIsElevated ? 'active' : '']"
					class="routeLink textLink"
					routerLink="/support-dashboard"
					>Support Dashboard</a
				>
				<a class="routeLink textLink" target="_blank" rel="noopener noreferrer" href="https://wfdss.firenet.gov/help/Content/00-General/User-Support.htm"
					>User Support</a
				>
			</div>
			<div class="buttons-ga-container">
				<div class="route-container">
					<span *ngIf="gaPrepLevel">{{ gaAbbreviation }} PL: {{ gaPrepLevel }} </span>
					<span *ngIf="gaPrepLevel && nationalPrepLevel">|</span>
					<span *ngIf="nationalPrepLevel">National PL: {{ nationalPrepLevel }}</span>
				</div>
				<div class="route-container" style="align-items: center">
					<button [routerLink]="'/notifications'" routerLinkActive="active" aria-label="Notifications Link">
						<mat-icon>notifications</mat-icon>
          </button>
					<button [matMenuTriggerFor]="userMenu" aria-label="Profile Menu">
						<mat-icon>perm_identity</mat-icon>
					</button>
				</div>
			</div>
		</div>
	</mat-toolbar-row>
	<mat-toolbar-row *ngIf="this.toolbarOverflowing === true" style="display: flex; justify-content: space-between">
		<a id="wfdss-logo" href="https://wfdss.firenet.gov/help" target="_blank" rel="noopener noreferrer" aria-label="Link to WFDSS Help website">
			<img src="assets/images/wfdss/wfdss_logo_only.svg" alt="WFDSS Help Website" />
		</a>
		<button mat-button [matMenuTriggerFor]="menu" aria-label="Main menu">
			<mat-icon style="color: white;">menu</mat-icon>
		</button>
		<mat-menu #menu="matMenu">
			<a mat-menu-item routerLink="/myHome" routerLinkActive="active">My Home</a>
			<a mat-menu-item routerLink="/incidents" routerLinkActive="active">Incidents</a>
			<a
				mat-menu-item
				[ngClass]="userIsElevated ? '' : 'inactive-routeLink'"
				[routerLinkActive]="[userIsElevated ? 'active' : '']"
				[routerLink]="userIsElevated ? '/reports' : null"
				>Reports</a
			>
			<a mat-menu-item *ngIf="authenticationService.currentUser?.role?.roleType === 'SUPPORT'" class="routeLink textLink" routerLink="/support-dashboard"
				>Support Dashboard</a
			>
			<a mat-menu-item target="_blank" rel="noopener noreferrer" href="https://wfdss.firenet.gov/help/Content/00-General/User-Support.htm">User Support</a>
			<a mat-menu-item routerLink="/notifications" routerLinkActive="active">Notifications</a>
			<a *ngIf="authenticationService.isLoggedIn" mat-menu-item [routerLink]="authenticationService.isLoggedIn ? 'users/profile' : null">View Profile </a>
			<a
				*ngIf="userIsElevated"
				class="rm-outline"
				mat-menu-item
				[ngClass]="userIsElevated ? '' : 'inactive-routeButton'"
				[routerLink]="userIsElevated ? '/users/search' : null">
				Search Users
			</a>
			<a *ngIf="authenticationService.isLoggedIn" routerLink="/gae-staff-report" class="rm-outline" mat-menu-item>GAE Staff</a>
			<button class="rm-outline" mat-menu-item (click)="openDialog()">
				{{ authenticationService.isLoggedIn ? "Log Out" : "Login" }}
			</button>
		</mat-menu>
	</mat-toolbar-row>
</mat-toolbar>
